<template>
  <div class="sensitiveWord-revise">
    <el-dialog
      title="修改敏感词"
      :visible="dialogVisible"
      @open="dialogOpen"
      @close="dialogClose"
      width="480px"
      :close-on-click-modal="false"
      center
    >
      <div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
          <el-form-item label="内容:" prop="word">
            <el-input
              v-model="ruleForm.word"
              placeholder="请输入敏感词"
            ></el-input>
          </el-form-item>
          <el-form-item label="类型:" prop="type">
            <el-select
              v-model="ruleForm.type"
              placeholder="请选择类型"
              :value="reviseWord.type"
            >
              <el-option
                v-for="(item, index) in options"
                :key="index"
                :value="item"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogClose">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "",
  props: {
    dialogVisible: {
      type: Boolean,
      require: true,
    },
    options: {
      type: Array,
    },
    reviseWord: {
      type: Object,
    },
  },
  data() {
    return {
      ruleForm: {
        word: "123",
        type: "",
      },
      rules: {
        word: [{ required: true, message: "请输入敏感词", trigger: "blur" }],
        type: [{ required: true, message: "请选择类型", trigger: "change" }],
      },
    };
  },
  // watch: {
  //   reviseWord: {
  //     handler(val) {
  //       this.$set(this.ruleForm, "word", this.reviseWord.word);
  //       this.$set(this.ruleForm, "type", this.reviseWord.type);
  //     },
  //   },
  // },
  inject: ["refresh"],
  methods: {
    dialogOpen() {
      // 默认显示选中修改敏感词的内容和类别
      let { word, type } = this.reviseWord;
      this.ruleForm.word = word;
      this.ruleForm.type = type;
    },
    dialogClose() {
      this.ruleForm.word = "";
      this.ruleForm.type = "";
      this.$emit("update:dialogVisible", false);
      this.$refs["ruleForm"].clearValidate();//移除表单检验结果
    },
    confirm() {
      let { createBy, id } = this.reviseWord;
      // 验证信息是否完整
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.put(this.$url.reviseWords, {
            id: id,
            word: this.ruleForm.word,
            type: this.ruleForm.type,
            updateBy: createBy, //修改人id
          })
            .then((res) => {
              // console.log(res);
              if (res.code == 200 && res.data != 0) {
                this.$message.success(res.msg);
                // 刷新列表
                this.refresh();
                // 关闭弹出框
                this.dialogClose();
              } else {
                this.$message.error(res.msg);
              }
            })
            .catch((err) => {
              this.$message.error(res.msg);
              // console.log(err);
            });
          // 刷新列表
          this.refresh();
          // 关闭弹出框
          this.dialogClose();
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped >
@import "./sensitiveWord-revise.scss";
</style>